function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { callPrivateApiAction } from "./api";
import { createReducer } from "@reduxjs/toolkit";
import { memoize } from "proxy-memoize";
import { isAnafSpvInAnyActivatedState, MY_COMPANY_ANAF_SPV_STATUSES } from "../features/myCompanies/utils";
import { getLocalStorageItem, removeLocalStorageItem, setLocalStorageItem } from "../features/app/utils";
var SELECTED_COMPANY_LOCAL_STORAGE_KEY = "robill_selected_company_id";
/*******************
 * ACTION TYPES
 *******************/ var actionTypes = {
    LOAD_MY_COMPANIES_PAIRS: "myCompanies/LOAD_MY_COMPANIES_PAIRS",
    LOADED_MY_COMPANIES_PAIRS: "myCompanies/LOADED_MY_COMPANIES_PAIRS",
    CHANGE_SELECTED_COMPANY: "myCompanies/CHANGE_SELECTED_COMPANY",
    RESET_PAIRS_AND_SELECTED_COMPANY: "myCompanies/RESET_PAIRS_AND_SELECTED_COMPANY",
    INITIALIZE_WITH_EMPTY_PAIRS: "myCompanies/INITIALIZE_WITH_EMPTY_PAIRS",
    UPDATE_ANAF_SPV_STATUS: "myCompanies/UPDATE_ANAF_SPV_STATUS",
    UPDATE_NB_INVOICES: "myCompanies/UPDATE_NB_INVOICES"
};
var findMyCompanyId = function(companies) {
    var searchVal = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
    var result = companies.find(function(item) {
        return item.id === searchVal;
    });
    return result ? result.id : null;
};
/*******************
 * REDUCER
 *******************/ export default createReducer({
    myCompaniesPairs: [],
    selectedCompanyId: null,
    isLoadingCompaniesPairs: false
}, function(builder) {
    builder.addCase(actionTypes.LOAD_MY_COMPANIES_PAIRS, function(state) {
        return _object_spread_props(_object_spread({}, state), {
            isLoadingCompaniesPairs: true
        });
    });
    builder.addCase(actionTypes.LOADED_MY_COMPANIES_PAIRS, function(state, action) {
        var payload = action.payload;
        return _object_spread_props(_object_spread({}, state), {
            myCompaniesPairs: payload.myCompaniesPairs,
            selectedCompanyId: payload.selectedCompanyId,
            isLoadingCompaniesPairs: false
        });
    });
    builder.addCase(actionTypes.CHANGE_SELECTED_COMPANY, function(state, action) {
        return _object_spread_props(_object_spread({}, state), {
            selectedCompanyId: action.payload.newSelectedCompanyId
        });
    });
    builder.addCase(actionTypes.RESET_PAIRS_AND_SELECTED_COMPANY, function() {
        return {
            myCompaniesPairs: [],
            selectedCompanyId: null,
            isLoadingCompaniesPairs: false
        };
    });
    builder.addCase(actionTypes.INITIALIZE_WITH_EMPTY_PAIRS, function(state) {
        return _object_spread_props(_object_spread({}, state), {
            myCompaniesPairs: []
        });
    });
    builder.addCase(actionTypes.UPDATE_ANAF_SPV_STATUS, function(state, action) {
        var payload = action.payload;
        var normalizedPayloadId = typeof payload.myCompanyId === "string" ? parseInt(payload.myCompanyId) : payload.myCompanyId;
        var myCompany = state.myCompaniesPairs.find(function(item) {
            return item.id === normalizedPayloadId;
        });
        if (myCompany) {
            myCompany.anafSpvStatus = payload.anafSpvStatus;
            myCompany.isMigratedToAnafSpvEtransport = payload.isMigratedToAnafSpvEtransport;
        }
        var filteredCompaniesPairs = state.myCompaniesPairs.filter(function(item) {
            return item.id !== normalizedPayloadId;
        });
        state.myCompaniesPairs = _to_consumable_array(filteredCompaniesPairs).concat([
            myCompany
        ]);
    });
    builder.addCase(actionTypes.UPDATE_NB_INVOICES, function(state, action) {
        var payload = action.payload;
        var myCompany = state.myCompaniesPairs.find(function(item) {
            return item.id === payload.myCompanyId;
        });
        myCompany.nbInvoices = payload.nbInvoices;
        var filteredCompaniesPairs = state.myCompaniesPairs.filter(function(item) {
            return item.id !== payload.myCompanyId;
        });
        state.myCompaniesPairs = _to_consumable_array(filteredCompaniesPairs).concat([
            myCompany
        ]);
    });
});
/*******************
 * ACTIONS
 *******************/ export var myCompaniesActions = {
    updateAnafSpvStatus: function updateAnafSpvStatus(param) {
        var myCompanyId = param.myCompanyId, anafSpvStatus = param.anafSpvStatus, isMigratedToAnafSpvEtransport = param.isMigratedToAnafSpvEtransport;
        return {
            type: actionTypes.UPDATE_ANAF_SPV_STATUS,
            payload: {
                myCompanyId: myCompanyId,
                anafSpvStatus: anafSpvStatus,
                isMigratedToAnafSpvEtransport: isMigratedToAnafSpvEtransport
            }
        };
    },
    updateNbInvoices: function updateNbInvoices(param) {
        var myCompanyId = param.myCompanyId, nbInvoices = param.nbInvoices;
        return {
            type: actionTypes.UPDATE_NB_INVOICES,
            payload: {
                myCompanyId: myCompanyId,
                nbInvoices: nbInvoices
            }
        };
    },
    getMyCompaniesPairs: function getMyCompaniesPairs(abortControllerSignal, myCompanyIdFromQuery) {
        var _this = this;
        return /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(dispatch) {
                var response, localSelectedCompanyId, selectedCompanyIdFromQuery, selectedCompanyIdFromLocalStorage, selectedId, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            dispatch({
                                type: actionTypes.LOAD_MY_COMPANIES_PAIRS
                            });
                            return [
                                4,
                                dispatch(_this.listMyCompanies({
                                    page: 1,
                                    perPage: 100,
                                    sortBy: "name",
                                    sortDir: "asc",
                                    search: "",
                                    filters: []
                                }, abortControllerSignal))
                            ];
                        case 1:
                            response = _state.sent();
                            localSelectedCompanyId = getLocalStorageItem(SELECTED_COMPANY_LOCAL_STORAGE_KEY);
                            selectedCompanyIdFromQuery = findMyCompanyId(response && response.body && response.body.items, parseInt(myCompanyIdFromQuery));
                            selectedCompanyIdFromLocalStorage = findMyCompanyId(response && response.body && response.body.items, parseInt(localSelectedCompanyId));
                            //If no company with the selected id from query or from localStorage exists, select the first company from pairs
                            selectedId = selectedCompanyIdFromQuery || selectedCompanyIdFromLocalStorage || response.body && response.body.items && response.body.items[0] && response.body.items[0].id || null;
                            if (selectedId) {
                                setLocalStorageItem(SELECTED_COMPANY_LOCAL_STORAGE_KEY, selectedId);
                            } else {
                                removeLocalStorageItem(SELECTED_COMPANY_LOCAL_STORAGE_KEY);
                            }
                            dispatch({
                                type: actionTypes.LOADED_MY_COMPANIES_PAIRS,
                                payload: {
                                    myCompaniesPairs: response && response.body && response.body.items,
                                    selectedCompanyId: selectedId
                                }
                            });
                            return [
                                2,
                                response.body && response.body.items
                            ]; //.items since we're not looping so count is not used
                        case 2:
                            error = _state.sent();
                            _this.resetPairsAndSelectedCompany();
                            throw error;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(dispatch) {
                return _ref.apply(this, arguments);
            };
        }();
    },
    changeSelectedCompany: function changeSelectedCompany(id) {
        return function(dispatch, getState) {
            var newSelectedCompanyId = findMyCompanyId(myCompaniesSelectors.myCompaniesPairs(getState()), id);
            if (!newSelectedCompanyId) {
                throw new Error("Invalid company id");
            }
            if (newSelectedCompanyId === myCompaniesSelectors.selectedCompanyId(getState())) {
                return;
            }
            setLocalStorageItem(SELECTED_COMPANY_LOCAL_STORAGE_KEY, newSelectedCompanyId);
            dispatch({
                type: actionTypes.CHANGE_SELECTED_COMPANY,
                payload: {
                    newSelectedCompanyId: newSelectedCompanyId
                }
            });
        };
    },
    resetPairsAndSelectedCompany: function resetPairsAndSelectedCompany() {
        return function(dispatch) {
            //Do not reset the localStorage selected company here
            dispatch({
                type: actionTypes.RESET_PAIRS_AND_SELECTED_COMPANY
            });
        };
    },
    initializeWithEmptyPairs: function initializeWithEmptyPairs() {
        return function(dispatch) {
            dispatch({
                type: actionTypes.INITIALIZE_WITH_EMPTY_PAIRS
            });
        };
    },
    uploadLogoApi: function uploadLogoApi(file, abortControllerSignal) {
        var formData = new FormData();
        formData.append("file", file, file.name);
        return callPrivateApiAction("post", "/v1/my-companies/logo", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            signal: abortControllerSignal
        });
    },
    createMyCompany: function createMyCompany(details, abortControllerSignal) {
        return callPrivateApiAction("post", "/v1/my-companies", details, {
            signal: abortControllerSignal
        });
    },
    listMyCompanies: function listMyCompanies(param, abortControllerSignal) {
        var page = param.page, perPage = param.perPage, sortBy = param.sortBy, sortDir = param.sortDir, search = param.search, filters = param.filters;
        var params = {
            page: page,
            perPage: perPage,
            sortBy: sortBy,
            sortDir: sortDir
        };
        if (search) {
            params.search = search;
        }
        if (filters) {
            params.filters = filters;
        }
        return callPrivateApiAction("get", "/v1/my-companies", params, {
            signal: abortControllerSignal
        });
    },
    getMyCompanyById: function getMyCompanyById(myCompanyId, abortControllerSignal) {
        var _this = this;
        return function(dispatch) {
            return dispatch(callPrivateApiAction("get", "/v1/my-companies/".concat(myCompanyId), null, {
                signal: abortControllerSignal
            })).then(function(response) {
                var body = response.body;
                //? To have the updated selectors since some of them use the pairs req response
                dispatch(_this.updateAnafSpvStatus({
                    myCompanyId: myCompanyId,
                    anafSpvStatus: body.anafSpvStatus,
                    isMigratedToAnafSpvEtransport: body.isMigratedToAnafSpvEtransport ? 1 : 0
                }));
                return body;
            });
        };
    },
    updateMyCompany: function updateMyCompany(param, abortControllerSignal) {
        var details = param.details, myCompanyId = param.myCompanyId;
        return callPrivateApiAction("put", "/v1/my-companies/".concat(myCompanyId), details, {
            signal: abortControllerSignal
        });
    },
    deleteMyCompany: function deleteMyCompany(myCompanyId, abortControllerSignal) {
        return callPrivateApiAction("delete", "/v1/my-companies/".concat(myCompanyId), null, {
            signal: abortControllerSignal
        });
    },
    finishActivateAnafSpv: function finishActivateAnafSpv(param, abortControllerSignal) {
        var token = param.token, myCompanyId = param.myCompanyId;
        return callPrivateApiAction("post", "/v1/my-companies/".concat(myCompanyId, "/anaf-spv/finish"), {
            token: token
        }, {
            signal: abortControllerSignal
        });
    },
    changeCertificateExpirationDate: function changeCertificateExpirationDate(param, abortControllerSignal) {
        var details = param.details, myCompanyId = param.myCompanyId;
        return function(dispatch) {
            return dispatch(callPrivateApiAction("put", "/v1/my-companies/".concat(myCompanyId, "/anaf-spv/certificate-expiration-date"), details, {
                signal: abortControllerSignal
            })).then(function(response) {
                return response.body;
            });
        };
    },
    deleteCertificateExpirationDate: function deleteCertificateExpirationDate(myCompanyId, abortControllerSignal) {
        return callPrivateApiAction("delete", "/v1/my-companies/".concat(myCompanyId, "/anaf-spv/certificate-expiration-date"), null, {
            signal: abortControllerSignal
        });
    },
    listEfactura: function listEfactura(myCompanyId, param, abortControllerSignal) {
        var page = param.page, perPage = param.perPage, sortBy = param.sortBy, sortDir = param.sortDir, search = param.search, filters = param.filters;
        var params = {
            page: page,
            perPage: perPage,
            sortBy: sortBy,
            sortDir: sortDir
        };
        if (search) {
            params.search = search;
        }
        if (filters) {
            params.filters = filters;
        }
        return callPrivateApiAction("get", "/v1/my-companies/".concat(myCompanyId, "/efactura"), params, {
            signal: abortControllerSignal
        });
    },
    revokeAnafSpv: function revokeAnafSpv(myCompanyId, abortControllerSignal) {
        return callPrivateApiAction("delete", "/v1/my-companies/".concat(myCompanyId, "/anaf-spv"), null, {
            signal: abortControllerSignal
        });
    },
    getAccountantAnafSpvActivationLink: function getAccountantAnafSpvActivationLink(myCompanyId, abortControllerSignal) {
        return callPrivateApiAction("get", "/v1/my-companies/".concat(myCompanyId, "/anaf-spv/accountant"), null, {
            signal: abortControllerSignal
        });
    },
    sendAccountantAnafSpvInvitation: function sendAccountantAnafSpvInvitation(param, abortControllerSignal) {
        var myCompanyId = param.myCompanyId, details = param.details;
        return callPrivateApiAction("post", "/v1/my-companies/".concat(myCompanyId, "/anaf-spv/accountant"), details, {
            signal: abortControllerSignal
        });
    },
    verifyFinishActivateAnafSpvAccountant: function verifyFinishActivateAnafSpvAccountant(params, abortControllerSignal) {
        return callPrivateApiAction("get", "/v1/anaf-spv/accountant/verify", params, {
            signal: abortControllerSignal
        });
    },
    finishActivateAnafSpvAccountant: function finishActivateAnafSpvAccountant(data, abortControllerSignal) {
        return callPrivateApiAction("post", "/v1/anaf-spv/accountant/finish", data, {
            signal: abortControllerSignal
        });
    },
    listMyCompanyExports: function listMyCompanyExports(myCompanyId, abortControllerSignal) {
        return callPrivateApiAction("get", "/v1/my-companies/".concat(myCompanyId, "/exports"), null, {
            signal: abortControllerSignal
        });
    },
    requestDatabaseExport: function requestDatabaseExport(myCompanyId, abortControllerSignal) {
        return callPrivateApiAction("post", "/v1/my-companies/".concat(myCompanyId, "/exports/database"), null, {
            signal: abortControllerSignal
        });
    }
};
/*******************
 * SELECTORS
 *******************/ var myCompaniesPairs = memoize(function(state) {
    return state.myCompanies.myCompaniesPairs;
});
var selectedCompanyId = memoize(function(state) {
    return state.myCompanies.selectedCompanyId;
});
var myCompanyAnafSpvStatus = memoize(function(state) {
    var _myCompaniesPairs_find;
    return (_myCompaniesPairs_find = myCompaniesPairs(state).find(function(item) {
        return item.id === selectedCompanyId(state);
    })) === null || _myCompaniesPairs_find === void 0 ? void 0 : _myCompaniesPairs_find.anafSpvStatus;
});
export var myCompaniesSelectors = {
    myCompaniesPairs: myCompaniesPairs,
    myCompanyAnafSpvStatus: myCompanyAnafSpvStatus,
    myCompanyAnafSpvStatusIsActive: memoize(function(state) {
        return myCompanyAnafSpvStatus(state) === MY_COMPANY_ANAF_SPV_STATUSES.ACTIVE;
    }),
    myCompanyHasAnafSpvEnabled: memoize(//Checks if status is any from 'active' statuses
    function(state) {
        return isAnafSpvInAnyActivatedState(myCompanyAnafSpvStatus(state));
    }),
    isAnafSpvEnabledForCompany: memoize(//To be used with the id* from params, on EfacturaPage, needs == since sometimes it* can be int sometimes a string
    function(state) {
        return function(companyId) {
            var _myCompaniesPairs_find;
            return isAnafSpvInAnyActivatedState((_myCompaniesPairs_find = myCompaniesPairs(state).find(function(item) {
                return item.id == companyId;
            })) === null || _myCompaniesPairs_find === void 0 ? void 0 : _myCompaniesPairs_find.anafSpvStatus);
        };
    }),
    myCompanyIsMigratedToAnafSpvEtransport: memoize(function(state) {
        var _myCompaniesPairs_find;
        return !!((_myCompaniesPairs_find = myCompaniesPairs(state).find(function(item) {
            return item.id === selectedCompanyId(state);
        })) === null || _myCompaniesPairs_find === void 0 ? void 0 : _myCompaniesPairs_find.isMigratedToAnafSpvEtransport);
    }),
    companyIsMigratedToAnafSpvEtransport: memoize(function(state) {
        return function(myCompanyId) {
            var _myCompaniesPairs_find;
            return !!((_myCompaniesPairs_find = myCompaniesPairs(state).find(function(item) {
                return item.id.toString() === myCompanyId.toString();
            })) === null || _myCompaniesPairs_find === void 0 ? void 0 : _myCompaniesPairs_find.isMigratedToAnafSpvEtransport);
        };
    }),
    isSelectedCompanyVatPayer: memoize(function(state) {
        return state.myCompanies.selectedCompanyId && (state.myCompanies.myCompaniesPairs || []).map(function(company) {
            return company.vatPayer === 1 ? company.id : null;
        }).filter(Boolean).includes(state.myCompanies.selectedCompanyId);
    }),
    hasSelectedCompanyVatUponCollection: memoize(function(state) {
        return state.myCompanies.selectedCompanyId && (state.myCompanies.myCompaniesPairs || []).map(function(company) {
            return company.vatUponCollection === 1 ? company.id : null;
        }).filter(Boolean).includes(state.myCompanies.selectedCompanyId);
    }),
    selectedCompanyId: selectedCompanyId,
    myCompanyNbInvoices: memoize(function(state) {
        var _myCompaniesPairs_find;
        return (_myCompaniesPairs_find = myCompaniesPairs(state).find(function(item) {
            return item.id === selectedCompanyId(state);
        })) === null || _myCompaniesPairs_find === void 0 ? void 0 : _myCompaniesPairs_find.nbInvoices;
    }),
    isLoadingCompaniesPairs: memoize(function(state) {
        return state.myCompanies.isLoadingCompaniesPairs;
    })
};
